import classNames from 'classnames';
import React, { FC } from 'react';
import classes from './loader.module.scss';

const Loader: FC<{className?: string}> = ({className}) => {
    return (<div className={classNames(classes.custom_loader, className)}></div>)
}

export const FullLoader: FC<{className?: string, loaderClassName?: string}> = ({className, loaderClassName}) => {
    return (
        <div className={classNames(classes.full_loader, className)}>
            <Loader className={loaderClassName}/>
        </div>
    );
}

export default Loader;